import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import { format } from "date-fns";
import { getUnitPriceForQuantity } from "./utils";

const driversName = {
  Victor: "1 VICTOR",
  Junior: "2 JUNIOR",
  Luis: "3 LUIS",
  Rodrigo: "4 RODRIGO",
  Belen: "5 BELEN",
  Jose: "8 JOSE",
  Carlos: "9 CARLOS",
  Ricardo: "10 RICARDO",
  Patricio: "14 PATRICIO",
  Sergio: "15 SERGIO",
  Aldo: "16 ALDO",
  Fabian: "17 FABIAN",
  Eduardo: "18 EDUARDO",
  Stefano: "19 STEFANO",
  Hugo: "20 HUGO",
  Berrios: "21 BERRIOS",
  ZM: "22 ZM",
  Empresa: "23 EMPRESA",
  Nuñez: "24 NUÑEZ",
  Javier: "25 JAVIER",
  Allan: "26 ALLAN",
  LuisC: "27 LUIS C",
  EduardoV: "28 EDUARDO V",
  PatricioS: "29 PATRICIO S",
  Mauricio: "30 MAURICIO",
  "Extra uno": "50 EXTRA UNO",
  "Extra dos": "51 EXTRA DOS",
  "Extra tres": "52 EXTRA TRES",
  "Extra cuatro": "53 EXTRA CUATRO",
  "Extra cinco": "54 EXTRA CINCO",
};

export const generateRoutePDF = (orders, driver, date) => {
  const pdf = new jsPDF({ orientation: "landscape" });

  pdf.setProperties({
    title: "Route Orders",
  });

  pdf.setFontSize(10);

  // Add driver name and date
  const companyName = "Mundo Tito";
  const reportTitle = "Ruta Diaria";

  // Summary Statistics
  const totalOrders = orders.length;
  const totalAmount = orders.reduce((sum, order) => sum + order.amount, 0);

  // Add company logo (if available) and name
  // pdf.addImage(companyLogo, 'PNG', 10, 10, 50, 20); // Assuming you have a logo image
  pdf.setFontSize(16);
  pdf.setFont("helvetica", "normal");
  pdf.text(companyName + " - " + reportTitle, 10, 20, {
    align: "left",
  });

  // Add driver information, route date, report generation date, and summary statistics
  pdf.setFontSize(10);
  pdf.setFont("helvetica", "normal");

  pdf.setTextColor(50);
  pdf.text(`Conductor: ${driver}`, 10, 30);
  pdf.text(`Día de Ruta: ${date}`, 10, 35);

  pdf.text(`Cantidad de Pedidos: ${totalOrders}`, 100, 30);
  pdf.text(`Monto Total: $${totalAmount.toFixed(0)}`, 100, 35);

  pdf.setLineWidth(0.1);
  pdf.setDrawColor(128);
  pdf.line(10, 40, pdf.internal.pageSize.getWidth() - 10, 40); // Gray line

  // Prepare the table columns
  const columns = [
    { title: "PAGO", dataKey: "payment_status" },
    { title: "N°", dataKey: "daily_id" },
    { title: "NOMBRE", dataKey: "name" },
    { title: "DIRECCIÓN", dataKey: "address" },
    { title: "BLOCK Y/O DEPTO", dataKey: "block_depto" },
    { title: "COMUNA", dataKey: "city" },
    { title: "FONO", dataKey: "phone_number" },
    { title: "PEDIDO", dataKey: "order_details" },
    { title: "A PAGAR", dataKey: "amount" },
    { title: "MEDIO DE PAGO", dataKey: "payment_method" },
    { title: "OBSERVACIONES", dataKey: "delivery_note" },
    { title: "VENDEDOR", dataKey: "seller_name" },
    { title: "BOL/FAC", dataKey: "order_type" },
  ];

  orders.sort((a, b) => a.daily_id - b.daily_id);

  // Prepare the table rows
  // console.log("rows: ", orders);
  const rows = orders.map((order) => ({
    payment_status: "",
    daily_id: order.daily_id,
    name: order.name?.toUpperCase(),
    address: order.address?.split(",")[0]?.toUpperCase(),
    block_depto: order.address?.split(",")[1]?.toUpperCase(),
    city: order.city?.toUpperCase(),
    phone_number: order.phone_number?.replace(/[^\x20-\x7E]/g, ""),
    // order_details: "", // Set to empty string to avoid default rendering
    // products: order.products.map((p) => ({
    //   quantity: p.quantity,
    //   product_name: p.product_name.toUpperCase(),
    //   variation: p.variation.toUpperCase(),
    // })),
    order_details: order.products
      .map((p) =>
        p.not_found_name
          ? `${p.quantity} x ${p.not_found_name
              ?.replace(/[^\x20-\x7E]/g, "")
              .toUpperCase()} (${p.not_found_variant
              ?.replace(/[^\x20-\x7E]/g, "")
              .toUpperCase()})`
          : `${p.quantity} x ${p.product_name?.toUpperCase()} (${
              p.variant.toLowerCase() === "notfound"
                ? p.not_found_variant?.toUpperCase()
                : p.variant.toUpperCase()
            })`,
      )
      .join("\n"),
    amount: order.amount,
    payment_method: order.payment_info_array?.[0]?.payment_method?.toUpperCase(),
    delivery_note: order.delivery_info_array[
      order.delivery_info_array.length - 1
    ].delivery_note
      ?.replace(/[^\x20-\x7E]/g, "")
      .toUpperCase(),
    seller_name: order.seller_name?.toUpperCase(),
    order_type: order.order_type?.toUpperCase() === "FACTURA" ? "FAC" : "BOL",
  }));

  for (let i = 0; i < 4; i++) {
    rows.push({
      payment_status: "",
      daily_id: "",
      name: "",
      address: "",
      block_depto: "",
      city: "",
      phone_number: "",
      order_details: "",
      amount: "",
      payment_method: "",
      delivery_note: "",
      seller_name: "",
    });
  }

  // Add the table to the PDF
  pdf.autoTable({
    head: [columns.map((col) => col.title)],
    body: rows.map((row) => columns.map((col) => row[col.dataKey])),
    startY: 45,
    theme: "plain", // Ensure no default styling is applied
    headStyles: {
      fontStyle: "bold",
      fillColor: [255, 255, 255], // No background color
    },
    styles: {
      fontSize: 8,
      lineColor: [0, 0, 0], // Black lines for borders
      lineWidth: 0.1, // Border width
    },
    tableLineColor: [0, 0, 0], // Black table border
    tableLineWidth: 0.1, // Table border width

    didParseCell: (data) => {
      // Check if this is one of the last 4 rows.
      // rows.length includes the empty rows we just pushed so:
      if (data.section === "body" && data.row.index >= rows.length - 4) {
        // Set a minimum cell height (e.g., 3 times normal height)
        data.cell.styles.minCellHeight = 30;
      }
      if (data.section === "head" && data.row.index === 0) {
        data.doc.setDrawColor(0, 0, 0);
        data.doc.setLineWidth(0.5);
        data.doc.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
        data.doc.setLineWidth(0.05);
      }
    },
    columnStyles: {
      1: { cellWidth: 12 }, // Narrower N° column
      2: { cellWidth: 20 }, // Wider NOMBRE column
      3: { cellWidth: 25 }, // Wider DIRECCIÓN column
      4: { cellWidth: 15 }, // Wider BLOCK Y/O DEPTO column
      5: { cellWidth: 25 }, // Wider COMUNA column
      6: { cellWidth: 20 }, // Wider FONO column
      7: { cellWidth: 40 }, // Wider PEDIDO column
      8: { cellWidth: 15 }, // Wider A PAGAR column
      9: { cellWidth: 20 }, // Wider MEDIO DE PAGO column
      10: { cellWidth: 35 }, // Wider OBSERVACIONES column
      11: { cellWidth: 20 }, // Wider VENDEDOR column
      12: { cellWidth: 10 }, // Wider TIPO DE DOCUMENTO column
    },
  });

  // Save the PDF
  pdf.save(`${driver.toUpperCase()}.pdf`);

  // const worksheet = XLSX.utils.json_to_sheet(rows);
  // const workbook = XLSX.utils.book_new();
  // XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  // XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
  // XLSX.writeFile(workbook, `${driver}.xlsx`);
};

export const generateLoadDriverPDF = (orders, driver, date) => {
  console.log("Generating PDF file for", driver);
  // console.log("Original data inside GenerateLoadDriverPDF", orders);

  const productOrders = {
    "4 SACOS SAFARI CRISTAL": 16,
    "ALIMENTO NOMADE": 999,
    "ARENA A GRANEL": 999,
    "ARENERO A": 999,
    "ARENERO C": 999,
    "ARENERO D": 999,
    "ARENERO E": 999,
    "ARENERO F": 999,
    CHURU: 999,
    GALLETA: 999,
    "LATA FANCY 80GR": 999,
    "MANGA 17 KG ROCAT": 15,
    "MANGA 20 KG TURBO CLEAN SACO 2 KG": 7,
    "MANGA 20 KG TURBO CLEAN SACO 4 KG": 8,
    "MANGA 20KG MININO": 6,
    "MANGA 20KG CITY CAT ": 12,
    "MANGA 20KG EASY CLEAN (4KG)": 4,
    "MANGA 20KG EASY CLEAN (8KG)": 3,
    "MANGA 20KG MUNDO TITO": 1,
    "MANGA 20KG TOP K9": 14,
    "MANGA 24 KG EASY CLEAN 3X8KG": 999,
    "MANGA 24KG EASY CLEAN": 5,
    "MANGA 24KG SAFARI": 11,
    REGALO: 999,
    "SACHET CAT CHOW": 999,
    "SACHET FELIX": 999,
    "SACO 10KG ALIMENTO FIT FORMULA": 17,
    "SACO 20 KG SAFARI": 10,
    "SACO 20 KG TURBO CLEAN": 9,
    "SACO 20KG BENGALA": 13,
    "SACO 20KG EASY CLEAN": 2,
    "SACO 20KG LOVE SAND": 999,
    "SNACK CREMOSO": 999,
  };
  const pdf = new jsPDF({ orientation: "portrait" });

  const borderX = 20;

  pdf.setProperties({
    title: "Loading List",
  });

  pdf.setProperties({
    title: "Route Orders",
  });

  pdf.setFontSize(10);

  // Add driver name and date
  const companyName = "Mundo Tito";
  const reportTitle = "Carga";

  // Add company logo (if available) and name
  // pdf.addImage(companyLogo, 'PNG', 10, 10, 50, 20); // Assuming you have a logo image
  pdf.setFontSize(16);
  pdf.setFont("helvetica", "normal");
  pdf.text(companyName + " - " + reportTitle, borderX, 20, {
    align: "left",
  });

  // Add driver information, route date, report generation date, and summary statistics
  // Add driver information, route date, report generation date, and summary statistics
  pdf.setFontSize(10);
  pdf.setFont("helvetica", "normal");

  pdf.setTextColor(50);
  pdf.text(`Conductor: ${driver}`, borderX, 30);
  pdf.text(`Día de Ruta: ${date}`, borderX, 35);

  pdf.setLineWidth(0.1);
  pdf.setDrawColor(128);
  pdf.line(borderX, 40, pdf.internal.pageSize.getWidth() - borderX, 40); // Gray line

  // Group products by name and variation
  const productGroups = orders.reduce((acc, order) => {
    order.products.forEach((product) => {
      // console.log("Product from productGroups", product);

      const productKey = `${
        product.not_found_name
          ? product.not_found_name.toUpperCase()
          : product.product_name?.toUpperCase()
      }-${
        product.not_found_variant
          ? product.not_found_variant.toUpperCase() + ", P." + order.daily_id
          : product.variant?.toUpperCase()
      }`;

      // console.log("product Key", productKey);
      if (!acc[productKey]) {
        acc[productKey] = {
          product_name: product.not_found_name
            ? product.not_found_name.toUpperCase()
            : product.product_name?.toUpperCase(),
          variant: product.not_found_variant
            ? product.not_found_variant.toUpperCase() + ", P." + order.daily_id
            : product.variant?.toUpperCase(),
          quantity: 0,
          not_found_name: product.not_found_name ? true : false,
        };
      }
      acc[productKey].quantity += product.quantity;
    });

    // console.log("FIRST ACC", acc);
    return acc;
  }, {});

  // console.log("ProductGroups", productGroups);

  // Prepare the table data
  const groupedProducts = Object.values(productGroups).reduce(
    (acc, product) => {
      // console.log("acc", acc);
      // console.log("product", product.not_found_name);

      const productName = product.product_name;
      if (!product.not_found_name) {
        if (!acc[productName]) {
          acc[productName] = [];
        }
        acc[productName].push(product);
      } else {
        if (!acc["ADICIONALES"]) {
          // Not found products
          acc["ADICIONALES"] = [];
        }
        acc["ADICIONALES"].push(product);
      }
      return acc;
    },
    {},
  );

  const tableData = [];
  console.log(
    "grouped products Object Keys",
    Object.keys(groupedProducts).sort(
      (a, b) => productOrders[a] - productOrders[b],
    ),
  );
  Object.keys(groupedProducts)
    .sort((a, b) => productOrders[a] - productOrders[b])
    .forEach((productName, index) => {
      console.log("Product Name", productName);
      if (productName !== "ADICIONALES") {
        tableData.push([
          {
            content: `${productName}`,
            colSpan: 3,
            styles: {
              halign: "justify",
              fontStyle: "bold",
              fillColor: [255, 255, 255],
            },
          },
          {
            content: "DEVOLUCIÓN",
            styles: {
              halign: "center",
              fontStyle: "bold",
              fillColor: [255, 255, 255],
            },
          },
          {
            content: "N° PEDIDO",
            styles: {
              halign: "center",
              fontStyle: "bold",
              fillColor: [255, 255, 255],
            },
          },
        ]);
        groupedProducts[productName].forEach((product) => {
          tableData.push([
            { content: "", styles: { fillColor: [255, 255, 255] } },
            {
              content: `${product.variant}`,
              styles: { fillColor: [255, 255, 255] },
            },
            {
              content: `${product.quantity}`,
              styles: { fillColor: [255, 255, 255], halign: "center" },
            },
            { content: "", styles: { fillColor: [255, 255, 255] } },
            { content: "", styles: { fillColor: [255, 255, 255] } },
          ]);
        });
      }
    });

  // LAST ITEM OF NOT FOUND PRODUCTS CALLED "ADICIONALES"
  if (groupedProducts["ADICIONALES"]) {
    tableData.push([
      {
        content: "ADICIONALES",
        colSpan: 3,
        styles: {
          halign: "left",
          fontStyle: "bold",
          fillColor: [255, 255, 255],
        },
      },
    ]);
    groupedProducts["ADICIONALES"].forEach((product) => {
      const aditionalProduct = product.product_name.replace(
        /[^\x20-\x7E]/g,
        "",
      );
      const additionaVariant =
        product.variant.replace(/[^\x20-\x7E]/g, "") === "NOTFOUND"
          ? ""
          : " - " + product.variant.replace(/[^\x20-\x7E]/g, "");
      // console.log(aditionalProduct);
      tableData.push([
        { content: "", styles: { fillColor: [255, 255, 255] } },
        {
          content: aditionalProduct + additionaVariant,
          styles: { fillColor: [255, 255, 255] },
        },
        {
          content: `${product.quantity}`,
          styles: { fillColor: [255, 255, 255], halign: "center" },
        },
        { content: "", styles: { fillColor: [255, 255, 255] } },
        { content: "", styles: { fillColor: [255, 255, 255] } },
      ]);
    });
  }

  // console.log(tableData);

  const tableWidth = 180; // Adjust based on your column widths and content
  const pageWidth = pdf.internal.pageSize.getWidth();
  const startX = (pageWidth - tableWidth) / 2;

  // Add the table to the PDF

  const startY = 40;
  let currentY = startY;

  tableData.forEach((product, id) => {
    console.log("product ", product);
    const eachTable = [product];
    const firstCurrentY = id === 0 ? startY : pdf.previousAutoTable.finalY;
    currentY = firstCurrentY + (product[0].colSpan === 3 ? 5 : 0);

    pdf.autoTable({
      startY: currentY,
      startX: 100,
      body: eachTable,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 0.5,
      },
      headStyles: {
        fillColor: [255, 255, 255], // No background color for header
        textColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      bodyStyles: {
        lineWidth: 0.1,
      },
      columnStyles: {
        0: { cellWidth: 10 }, // Adjust width of the first column
        1: { cellWidth: 90 }, // Adjust width of the second column
        2: { cellWidth: 10 }, // Adjust width of the third column
        3: { cellWidth: 30 }, // Adjust width of the third column
        4: { cellWidth: 40 }, // Adjust width of the third column
      },
      margin: startX, // Remove right and left margins
      // tableWidth: "wrap", // Ensure the table width wraps the content
      tableLineColor: [255, 255, 255],
      tableLineWidth: 0, // Table border width
    });
  });

  // currentY = currentY + 10;
  // const returnsTable = [];

  // returnsTable.push([
  //   {
  //     content: "DEVOLUCIÓN (PRODUCTO)",
  //     styles: { fillColor: [255, 255, 255], fontStyle: "bold" },
  //   },
  //   {
  //     content: "N° PEDIDO",
  //     styles: {
  //       fillColor: [255, 255, 255],
  //       fontStyle: "bold",
  //       halign: "right",
  //     },
  //   },
  // ]);

  // for (let i = 0; i < 10; i++) {
  //   returnsTable.push([
  //     { content: "", styles: { fillColor: [255, 255, 255] } },
  //     {
  //       content: "",
  //       styles: { fillColor: [255, 255, 255] },
  //     },
  //   ]);
  // }

  // pdf.autoTable({
  //   startY: currentY,
  //   startX: 100,
  //   body: returnsTable,
  //   theme: "grid",
  //   styles: {
  //     fontSize: 8,
  //     cellPadding: 0.5,
  //   },
  //   headStyles: {
  //     fillColor: [255, 255, 255], // No background color for header
  //     textColor: [0, 0, 0],
  //     lineWidth: 0.1,
  //   },
  //   bodyStyles: {
  //     lineWidth: 0.1,
  //   },
  //   columnStyles: {
  //     0: { cellWidth: 90 }, // Adjust width of the first column
  //     1: { cellWidth: 20 }, // Adjust width of the second column
  //   },
  //   margin: startX, // Remove right and left margins
  //   // tableWidth: "wrap", // Ensure the table width wraps the content
  //   tableLineColor: [255, 255, 255],
  //   tableLineWidth: 0, // Table border width
  // });

  currentY += 25;

  pdf.setFontSize(12);
  pdf.text("Pedidos Traspasados", 15, currentY);
  currentY += 5;

  const emptyTableData = Array.from({ length: 5 }, () => ["", "", ""]);

  pdf.autoTable({
    theme: "grid",
    styles: {
      fontSize: 8,
      cellPadding: 0.5,
    },
    headStyles: {
      fillColor: [255, 255, 255], // No background color for header
      textColor: [0, 0, 0],
      lineWidth: 0.1,
    },
    bodyStyles: {
      lineWidth: 0.1,
    },
    columnStyles: {
      0: { cellWidth: 10 }, // Adjust width of the first column
      1: { cellWidth: 40 }, // Adjust width of the second column
      2: { cellWidth: 130 }, // Adjust width of the third column
    },
    margin: startX, // Remove right and left margins
    // tableWidth: "wrap", // Ensure the table width wraps the content
    tableLineColor: [255, 255, 255],
    tableLineWidth: 0, // Table border width
    startY: currentY,
    head: [["N°", "CHOFER ORIGINAL", "PRODUCTOS"]],
    body: emptyTableData.map((row, index) => [
      { content: "", styles: { halign: "left" } },
      { content: "", styles: { halign: "left" } },
      { content: "", styles: { halign: "left" } },
    ]),
    styles: { fontSize: 8, cellPadding: 0.5 },
    columnStyles: {
      0: { cellWidth: 10 },
      1: { cellWidth: 40 },
      2: { cellWidth: 130 },
    },
  });

  currentY = pdf.lastAutoTable.finalY + 10;

  const pageHeight = pdf.internal.pageSize.getHeight();

  pdf.setFontSize(12);
  pdf.setFont("helvetica", "normal");
  pdf.text("Firma:", borderX, pageHeight - 15);
  pdf.line(
    40,
    pageHeight - 15,
    pdf.internal.pageSize.getWidth() - borderX,
    pageHeight - 15,
  ); // Signature line

  // Save the PDF
  pdf.save(`CARGA ${driver.toUpperCase()}.pdf`);
};

export const generateExcelAllDrivers = (orders, driver) => {
  orders.sort((a, b) => a.daily_id - b.daily_id);

  console.log(
    "This is the data insider the Generate Excel All Drivers",
    orders,
  );

  // Prepare the table rows
  // console.log("rows: ", orders);
  const rows = orders.map((order) => ({
    payment_status: "",
    daily_id: order.daily_id,
    Folio: order.documents?.find((d) => d.document_type === "BOLETA")?.document_id ?? "",
    name: order.name?.toUpperCase(),
    address: order.address?.split(",")[0]?.toUpperCase(),
    block_depto: order.address?.split(",")[1]?.toUpperCase(),
    city: order.city?.toUpperCase(),
    phone_number: order.phone_number,
    // order_details: "", // Set to empty string to avoid default rendering
    // products: order.products.map((p) => ({
    //   quantity: p.quantity,
    //   product_name: p.product_name.toUpperCase(),
    //   variation: p.variation.toUpperCase(),
    // })),
    order_details: order.products
      .sort((a, b) => a.product_name.localeCompare(b.product_name))
      .map((p) =>
        p.not_found_name
          ? `${p.quantity} x ${p.not_found_name
              ?.replace(/[^\x20-\x7E]/g, "")
              .toUpperCase()} (${p.not_found_variant
              ?.replace(/[^\x20-\x7E]/g, "")
              .toUpperCase()})`
          : `${p.quantity} x ${p.product_name?.toUpperCase()} (${
              p.variant.toLowerCase() === "notfound"
                ? p.not_found_variant?.toUpperCase()
                : p.variant.toUpperCase()
            })`,
      )
      .join("\n"),
    amount: order.amount,
    payment_method: order.payment_info_array?.[0]?.payment_method?.toUpperCase(),
    delivery_note: order.delivery_info_array[
      order.delivery_info_array.length - 1
    ].delivery_note
      ?.replace(/[^\x20-\x7E]/g, "")
      .toUpperCase(),
    seller_name: order.seller_name?.toUpperCase(),
    driver_name:
      driversName[
        driver.find(
          (driver) =>
            driver.personnel_id ===
            order.delivery_info_array[order.delivery_info_array.length - 1]
              .driver_id,
        ).name
      ],
    mangas: Number(
      order.products.length > 1
        ? order.products
            .map((item) => item.quantity * item.counts_as_manga)
            .reduce((acc, curr) => acc + curr)
        : (order.products[0].quantity * order.products[0].counts_as_manga) | 0,
    ),
    // .replace(/[^\x20-\x7E]/g, ""),
    // .toUpperCase(),
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
  XLSX.writeFile(workbook, "all.xlsx");
};

export const generateExcelForBilling = (
  orders,
  productPrices,
  TIVENDO_VARIANT_MAPPING,
  drivers,
  billingDate,
) => {
  const unifyProductQuantitiesPerOrder = (orders) => {
    return orders.map((order) => {
      const unifiedProductsQuantities = order.products.reduce((acc, curr) => {
        if (!acc[curr.product_id]) {
          acc[curr.product_id] = 0;
        }

        acc[curr.product_id] += curr.quantity;
        return acc;
      }, {});
      console.log("order_id", order.daily_id);
      console.log("unifiedProductsQuantities", unifiedProductsQuantities);
      return {
        order_id: order.order_id,
        productsSummary: unifiedProductsQuantities,
      };
    });
  };

  // Función auxiliar para obtener precio unitario sin IVA
  const getUnitPrice = (productId, totalQuantity) => {
    const productPriceInfo = productPrices.find(
      (p) => p.product_id === productId,
    );
    if (!productPriceInfo) return 0;

    return getUnitPriceForQuantity(productPriceInfo.prices, totalQuantity) || 0;
  };

  // Función auxiliar para encontrar el conductor
  const findDriver = (driverId) => {
    try {
      return (
        drivers.find((d) => d.personnel_id === driverId) || {
          name: "No Asignado",
        }
      );
    } catch (error) {
      console.error("Error al buscar conductor:", error);
      return { name: "No Asignado" };
    }
  };

  // Obtener cantidades unificadas por variante
  const unifiedQuantities = unifyProductQuantitiesPerOrder(orders);

  // Preparar los datos para el Excel
  const excelRows = [];

  // Push one more row with the tiles (duplicated).
  excelRows.push({
    "Número Documento (No folio)": "Número Documento (No folio)",
    TipoDocumento: "TipoDocumento",
    Fecha: "Fecha",
    Cliente: "Cliente",
    "Codigo Legal": "Codigo Legal",
    "Nombre Cliente": "Nombre Cliente",
    Direccion: "Direccion",
    Comuna: "Comuna",
    Ciudad: "Ciudad",
    Giro: "Giro",
    "Condicion Pago": "Condicion Pago",
    "Fecha Primer Pago": "Fecha Primer Pago",
    "Local de venta": "Local de venta",
    Vendedor: "Vendedor",
    "Cuenta Cliente": "Cuenta Cliente",
    "Centro Negocios Cliente": "Centro Negocios Cliente",
    "Clasificador 1 Cliente": "Clasificador 1 Cliente",
    "Clasificador 2 Cliente": "Clasificador 2 Cliente",
    Moneda: "Moneda",
    "Tasa de cambio": "Tasa de cambio",
    "Numero Impuesto": "Numero Impuesto",
    "Codigo Impuesto": "Codigo Impuesto",
    "Valor Impuesto": "Valor Impuesto",
    "Lista de Precio": "Lista de Precio",
    Glosa: "Glosa",
    "Es Documento Traspaso": "Es Documento Traspaso",
    "Numero Doc Asoc": "Numero Doc Asoc",
    "Tipo Doc Asoc": "Tipo Doc Asoc",
    "Folio Doc Asoc": "Folio Doc Asoc",
    "Fecha Doc Asoc": "Fecha Doc Asoc",
    "Razón Doc Asoc": "Razón Doc Asoc",
    "Número Detalle": "Número Detalle",
    "Tipo Producto": "Tipo Producto",
    CodigoProducto: "CodigoProducto",
    Comentario: "Comentario",
    Cantidad: "Cantidad",
    "Precio Unitario": "Precio Unitario",
    "Unidad de Medida": "Unidad de Medida",
    "Es Exento": "Es Exento",
    "Tipo Descuento": "Tipo Descuento",
    "Valor Descuento": "Valor Descuento",
    "Analisis Linea": "Analisis Linea",
    "Centro Negocios Linea": "Centro Negocios Linea",
    "Clasificador 1 Linea": "Clasificador 1 Linea",
    "Clasificador 2 Linea": "Clasificador 2 Linea",
    Lote: "Lote",
    "Cantidad Lote": "Cantidad Lote",
    FechaLote: "FechaLote",
    "Detalle Doc Asoc": "Detalle Doc Asoc",
    "Linea Doc Asoc": "Linea Doc Asoc",
    Bodega: "Bodega",
    "Identificador Externo (Unico)": "Identificador Externo (Unico)",
    "Numero Campo Personalizado": "Numero Campo Personalizado",
    "Nombre Campo Personalizado": "Nombre Campo Personalizado",
    "Valor Campo Personalizado": "Valor Campo Personalizado",
    "Numero Dscto Global": "Numero Dscto Global",
    "Nombre Dscto Global": "Nombre Dscto Global",
    "Tipo Dscto. Global": "Tipo Dscto. Global",
    "Porcentaje Dscto. Global": "Porcentaje Dscto. Global",
    "Valor Dscto. Global": "Valor Dscto. Global",
    "Listado Emails": "Listado Emails",
    MaderaComunaRolOrigen: "MaderaComunaRolOrigen",
    MaderaManzanaRolOrigen: "MaderaManzanaRolOrigen",
    MaderaManzanaPropiedadOrigen: "MaderaManzanaPropiedadOrigen",
    MaderaCodigoPlanCONAF: "MaderaCodigoPlanCONAF",
    MaderaLatitudOrigen: "MaderaLatitudOrigen",
    MaderaLongitudOrigen: "MaderaLongitudOrigen",
    MaderaSistemaReferencia: "MaderaSistemaReferencia",
  });

  orders.forEach((order) => {
    try {
      const lastDeliveryInfo =
        order.delivery_info_array[order.delivery_info_array.length - 1];
      const driverId = lastDeliveryInfo?.driver_id;
      const driverInfo = findDriver(driverId);
      const driverName = driverInfo.name; // Not all drivers are saved in Tivendo

      // Procesar cada producto en la orden
      order.products.forEach((product, index) => {
        const variantMapping = TIVENDO_VARIANT_MAPPING[product.variant_id];
        const tivendoCode = variantMapping ? variantMapping.code : "";

        const unitPrice = getUnitPrice(
          product.product_id,
          unifiedQuantities.find((item) => item.order_id === order.order_id)
            ?.productsSummary[product.product_id],
        );

        const typeOfDocument =
          order.order_type === "Factura" ? "fvarselect" : "boletaelecrs";

        excelRows.push({
          "Número Documento (No folio)":
            order.daily_id + "_" + driverName + "_" + billingDate,
          TipoDocumento: typeOfDocument,
          Fecha: billingDate,
          Cliente: "11.111.111-1",
          "Codigo Legal": "11.111.111-1",
          "Nombre Cliente": "GENERICO",
          Direccion: "GENERICO",
          Comuna: "GENERICO",
          Ciudad: "Santiago",
          Giro: "GENERICO",
          "Condicion Pago": "CONTADO",
          "Fecha Primer Pago": billingDate,
          "Local de venta": "Venta Despacho",
          Vendedor: "VENDEDOR",
          "Cuenta Cliente": "1110401001",
          "Centro Negocios Cliente": "",
          "Clasificador 1 Cliente": "",
          "Clasificador 2 Cliente": "",
          Moneda: "PESO",
          "Tasa de cambio": 1,
          "Numero Impuesto": 1,
          "Codigo Impuesto": "IVA",
          "Valor Impuesto": 19,
          "Lista de Precio": "",
          Glosa:
            "N° Pedido: " +
            order.daily_id +
            " - Direccion: " +
            order.address +
            " - Ciudad: " +
            order.city, // Client information and order details in this column
          "Es Documento Traspaso": "N", // Change it to "N"
          "Numero Doc Asoc": "",
          "Tipo Doc Asoc": "",
          "Folio Doc Asoc": "",
          "Fecha Doc Asoc": "",
          "Razón Doc Asoc": "",
          "Número Detalle": index + 1,
          "Tipo Producto": "A",
          CodigoProducto: tivendoCode,
          Comentario: `${product.product_name} ${product.variant} ${product.variant_id}`,
          Cantidad: product.quantity,
          "Precio Unitario": unitPrice,
          "Unidad de Medida": "UN",
          "Es Exento": "N",
          "Tipo Descuento": "",
          "Valor Descuento": "",
          "Analisis Linea": "3110101001",
          "Centro Negocios Linea": "EMPNEGVTAVTA000",
          "Clasificador 1 Linea": "",
          "Clasificador 2 Linea": "",
          Lote: "",
          "Cantidad Lote": "",
          FechaLote: "",
          "Detalle Doc Asoc": "",
          "Linea Doc Asoc": "",
          Bodega: "BODEGACENTRAL",
          "Identificador Externo (Unico)": "",
          "Numero Campo Personalizado": "",
          "Nombre Campo Personalizado": "",
          "Valor Campo Personalizado": "",
          "Numero Dscto Global": "",
          "Nombre Dscto Global": "",
          "Tipo Dscto. Global": "",
          "Porcentaje Dscto. Global": "",
          "Valor Dscto. Global": "",
          "Listado Emails": "",
          MaderaComunaRolOrigen: "",
          MaderaManzanaRolOrigen: "",
          MaderaManzanaPropiedadOrigen: "",
          MaderaCodigoPlanCONAF: "",
          MaderaLatitudOrigen: "",
          MaderaLongitudOrigen: "",
          MaderaSistemaReferencia: "",
        });
      });
    } catch (error) {
      console.error("Error procesando orden:", order.order_id, error);
    }
  });

  // Generar el archivo Excel
  try {
    const worksheet = XLSX.utils.json_to_sheet(excelRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Facturacion");

    // Guardar el archivo
    XLSX.writeFile(workbook, `facturacion_${billingDate}.xlsx`);
  } catch (error) {
    console.error("Error generando archivo Excel:", error);
  }
};

const vendedores = {
  Victor: "Victor",
  Junior: "Junior",
  Luis: "Luis",
  Rodrigo: "Rodrigo",
  Belen: "Belen",
  Jose: "José",
  Carlos: "Carlos",
  // Ricardo: "Extra 1",
  Patricio: "Patricio Saez Saldaño",
  Sergio: "Sergio",
  Aldo: "Aldo",
  Fabian: "Fabian verdugo",
  Eduardo: "Eduardo Varela",
  Mundotito: "Mundotito",
  "Extra uno": "Extra uno",
  "Extra dos": "Extra dos",
  "Extra tres": "Extra tres",
  "Extra cuatro": "Extra cuatro",
  "Extra cinco": "Extra cinco",
};
